export const NEW_PLAN_YEAR_KEY = 'addNewPlanYear';
